var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "discovery-form" },
    [
      _vm.schemaVersion === 1
        ? _c("form-v1", {
            ref: "form",
            attrs: {
              form: _vm.form,
              font: _vm.font,
              "in-frame": false,
              complete: _vm.isComplete
            },
            on: {
              complete: function($event) {
                return _vm.saveForm($event)
              }
            }
          })
        : _vm._e(),
      _vm.schemaVersion === 2
        ? _c("form-v2", {
            ref: "form",
            attrs: {
              form: _vm.form,
              font: _vm.font,
              "in-frame": false,
              complete: _vm.isComplete
            },
            on: {
              complete: function($event) {
                return _vm.saveForm($event)
              }
            }
          })
        : _vm._e(),
      _vm.schemaVersion === 0 && !_vm.notFound
        ? _c(
            "div",
            { staticClass: "discovery-form__loading" },
            [
              _c("v-progress-circular", {
                attrs: {
                  indeterminate: "",
                  color: "primary",
                  size: 36,
                  width: 3
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }